export default __webpack_public_path__ + "static/media/ISCO CLASS-3 EXAM PATTERN 2025.8727ffe0.pdf";